// extracted by mini-css-extract-plugin
export default {"clientFavTable":"ClientFavourite_clientFavTable__ZRp5a","pagination":"ClientFavourite_pagination__KEO6Z"};